import { CAN_SELF_COLLECT_PAYMENT_KEY } from '../types/dealerConfig.types';
import type { DealerConfigSetting } from '../types/dealerConfig.types';
import { readBooleanSetting } from './readBooleanSetting';

/** Resolve whether the dealer can self-collect payment from its raw config settings. */
export function resolveCanSelfCollectPayment(
    settings?: DealerConfigSetting[] | null,
): boolean {
    return readBooleanSetting(settings, CAN_SELF_COLLECT_PAYMENT_KEY);
}
